import { render, staticRenderFns } from "./PdfScanner.vue?vue&type=template&id=018d50cc&scoped=true&"
import script from "./PdfScanner.vue?vue&type=script&lang=js&"
export * from "./PdfScanner.vue?vue&type=script&lang=js&"
import style0 from "./PdfScanner.vue?vue&type=style&index=0&id=018d50cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018d50cc",
  null
  
)

export default component.exports